var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-view-container d-flex align-items-center flex-column"},[_vm._t("default"),_c('BaseFooter',{staticClass:"d-none d-md-flex"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }